import React from 'react';
import Link from 'next/link';
import { Home, BookOpen, Mic, Users, User } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const mobileNavItems = [
  { icon: Home, label: 'Home', href: '/student-dashboard', active: true },
  { icon: BookOpen, label: 'Learn', href: '/student-dashboard', active: false },
  { icon: Mic, label: 'Practice', href: '/student-dashboard', active: false },
  { icon: Users, label: 'Community', href: '/student-dashboard', active: false },
  { icon: User, label: 'Profile', href: '/student-dashboard', active: false },
];

export default function MobileBottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 h-16 bg-card border-t border-border flex items-center justify-around px-2 z-40">
      {mobileNavItems?.map((item) => {
        const Icon = item?.icon;
        return (
          <Link
            key={`mobile-bottom-${item?.label}`}
            href={item?.href}
            className={`flex flex-col items-center gap-1 px-3 py-1.5 rounded-xl transition-all ${
              item?.active ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon size={20} strokeWidth={item?.active ? 2.5 : 2} />
            <span className="text-xs font-semibold">{item?.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}